import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { SnackBarComponent } from '@shared/components/snack-bar/snack-bar.component';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class SnackBarService {

  constructor(private snackBar: MatSnackBar,
              private translate: TranslateService) {
  }

  openInfoMessage(key: string): void {
    const message: string = key ? this.translate.instant(key) : '';
    this.snackBar.open(message, '', {
      panelClass: 'mat-snack-bar--bui-info',
      duration: 3000,
    });
  }

  openSuccessMessage(key: string): void {
    const message: string = key ? this.translate.instant(key) : '';
    this.snackBar.open(message, '', {
      panelClass: 'mat-snack-bar--bui-success',
      duration: 3000,
    });
  }

  openErrorMessage(key: string | HttpErrorResponse, withDuration: boolean = true): void {
    const isKey = typeof key === 'string';
    let message = '';
    let errorCode = '';
    let stackTrace = '';
    if (isKey) {
      message = key ? this.translate.instant(key) : '';
      errorCode = key ? this.translate.instant(key) : '';
    } else {
      const errorObject = this.prepareErrorObject(key);
      message = errorObject.message;
      errorCode = errorObject.errorCode;
      stackTrace = errorObject.stackTrace;
    }

    const hasActions = !!stackTrace;
    this.snackBar.openFromComponent(SnackBarComponent, {
      panelClass: 'mat-snack-bar--bui-error',
      duration: (isKey && withDuration) ? 3000 : null,
      data: {message, errorCode, stackTrace, closeSnackBar: () => this.snackBar.dismiss(), hasActions: hasActions},
    });
  }

  private prepareErrorObject(response: HttpErrorResponse): { message: string; errorCode: string; stackTrace: string } {
    let payload: unknown = response.error;
    if (typeof payload === 'string') {
      try {
        payload = JSON.parse(payload);
      } catch {
        payload = {message: payload};
      }
    }
    if (!payload || typeof payload !== 'object' || Array.isArray(payload)) {
      payload = {message: response.message ?? ''};
    }
    const messageValue = typeof (payload as { message?: unknown }).message === 'string'
      ? (payload as { message: string }).message
      : '';
    const errorCodeValue = typeof (payload as { errorCode?: unknown }).errorCode === 'string'
      ? (payload as { errorCode: string }).errorCode
      : '';
    const stackTraceValue = typeof (payload as { stackTrace?: unknown }).stackTrace === 'string'
      ? (payload as { stackTrace: string }).stackTrace
      : '';
    return {
      message: messageValue ? this.translate.instant(messageValue) : '',
      errorCode: errorCodeValue ? this.translate.instant(errorCodeValue) : '',
      stackTrace: stackTraceValue,
    };
  }

  openInfoPrimaryMessage(message: string): void {
    this.snackBar.open(message, '', {
      panelClass: 'mat-snack-bar--bui-infoPrimary',
      duration: 3000,
    });
  }
}
